// src/properties/listingsApi.ts
import { apiClient } from "@maat/api-base";
var listingsApi = {
  getListingDetail: async (listingId) => {
    return apiClient.get(`/main/api/listings/${listingId}`);
  },
  /**
   * The other live listings on this listing's property, cheapest first, at most 20
   * (`truncated` says when there were more). Pass the guest's dates to price stay
   * totals and get `rooms_left`; both dates or neither.
   */
  getListingSiblings: async (listingId, params) => {
    return apiClient.get(`/main/api/listings/${listingId}/siblings`, { params });
  },
  /**
   * The offering is READ off `getListingDetail` — every surface that shows it
   * already has the detail payload — so only the write lives here.
   */
  updateListingCancellationConfig: async (listingId, config) => {
    return apiClient.put(`/main/api/listings/${listingId}/cancellation`, config);
  },
  updateListing: async (listingId, body) => {
    return apiClient.patch(`/main/api/listings/${listingId}`, body);
  },
  updateListingPricing: async (listingId, body) => {
    return apiClient.patch(`/main/api/listings/${listingId}/pricing`, body);
  },
  updateListingAmenities: async (listingId, body) => {
    return apiClient.patch(`/main/api/listings/${listingId}/amenities`, body);
  },
  updateListingHouseRules: async (listingId, body) => {
    return apiClient.patch(`/main/api/listings/${listingId}/house-rules`, body);
  },
  deleteListing: async (listingId) => {
    return apiClient.delete(`/main/api/listings/${listingId}`);
  },
  searchListings: async (params) => {
    return apiClient.get("/main/api/listings/search", {
      params,
      paramsSerializer: { indexes: null }
    });
  },
  getListingsByIds: async (ids) => {
    return apiClient.post("/main/api/listings/by-ids", { ids });
  },
  getListingCalendar: async (listingId, params) => {
    return apiClient.get(`/main/api/listings/${listingId}/calendar`, { params });
  },
  blockDates: async (listingId, payload) => {
    return apiClient.post(`/main/api/listings/${listingId}/calendar/block`, payload);
  },
  unblockDates: async (listingId, payload) => {
    return apiClient.post(`/main/api/listings/${listingId}/calendar/unblock`, payload);
  },
  getWorkspaceHostBlocks: async (params) => {
    return apiClient.get("/main/api/calendar/host-blocks", { params });
  },
  getWorkspaceIcalBlocks: async (params) => {
    return apiClient.get("/main/api/calendar/ical-blocks", { params });
  }
};

export {
  listingsApi
};
